<template lang="pug">
div
  v-navigation-drawer(v-model="drawer", fixed, temporary)
    v-list-item
      v-dialog(
        persistent,
        v-model="cameraDialog",
        transition="scale-transition",
        origin="center center"
      )
        template(v-slot:activator="{ on }")
          v-list-item-avatar(@click="vibrate()")
            v-img(
              :src="(selectedUser && selectedUser.imageUrl) || '/images/' + (selectedUser && selectedUser.role) + '.png'",
              v-on="on"
            )
        v-card(align="center")
          v-card-title
            .v-toolbar__title Capture Photo
          v-divider
          v-card-text
            croppa.imageBox(
              :initial-image="selectedUser && selectedUser.imageUrl",
              v-model="myCroppa",
              :width="225",
              :height="225",
              :outputwidth="225",
              :outputheight="225",
              :placeholder="'Click or Tap here'",
              :placeholder-font-size="20",
              :quality="3",
              canvas-color="transparent"
            )
          v-divider
          v-card-actions
            v-spacer
            v-btn(color="blue darken-1", text, @click="cameraDialog = false") Cancel
            v-btn(color="blue darken-1", text, @click="uploadImage") Upload
      v-icon(v-if="editedItem.imageUrl", @click="clearImage()", color="red") mdi-close
      |
      | {{  selectedUser &amp;&amp; selectedUser.fullName  }}
      v-spacer
      v-icon(@click="drawer = false") mdi-close
    v-list-item(v-if="$store.state.installPrompt", align="center")
      v-list-item-icon
      v-list-item-content
        v-btn(small) Install App
      v-list-item-action
    v-divider
    v-list(dense, nav)
      v-list-item(
        dense,
        nav,
        v-if="['GA', 'RM'].includes(selectedUser && selectedUser.role)",
        @click="vibrate(); $router.push('/admin')"
      )
        v-list-item-action
          v-icon mdi-account-settings
        v-list-item-title
          v-list-item-title Admin
      v-list-item
        v-dialog
          template(v-slot:activator="{ on }")
            v-list-item-icon
              v-icon mdi-help-box
            v-list-item-content
              v-list-item-title(v-on="on", :tile="true") About
          v-sheet.mx-auto(elevation="18", height="100%", width="100%")
            flip-card
              template(slot="front")
                v-img.white--text(src="/images/penzigo_logo.png")
                span.grey--text powered by Penzigo
              template(slot="back")
                v-label Solution Concept, Design &amp; DevOps by
                v-label Penzigo Technology Solutions Pvt Ltd
                v-label Unit 12(a) NITK STEP
                v-label National Institute of Technology Karmataka
                v-label Srinivas Nagar, Surathkal, Mangalore 575025
                v-label Made In India
      v-list-item
        v-list-item-icon
          v-icon mdi-finance
        v-list-item-content
          v-list-item-title Pricing Plan
      v-list-item
        v-list-item-icon
          v-icon
        v-list-item-content(
          @click="vibrate(); planDialog = true; drawer = false"
        )
          v-list-item-title 
            v-btn(small) {{  selectedGroup?selectedGroup.pricingPlan:&apos;None&apos;  }}
      v-dialog(v-model="planDialog", persistent)
        template 
          v-sheet.mx-auto(elevation="18", height="100%", width="100%")
            my-features
            center
              v-btn(
                @click="vibrate(); planDialog = false; $router.push('/admin')"
              ) Upgrade
              v-btn(@click="planDialog = false") Close
  v-app-bar(
    color="primary",
    hide-on-scroll,
    fixed,
    app,
    dense,
    dark,
    extended,
    extension-height="30px"
  )
    v-btn(icon)
      v-icon(@click.stop="vibrate(); drawer = !drawer") mdi-menu
    .header(align="center")
      v-toolbar-title
        div(
          style="color: orange; text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black",
          align="center"
        ) ezServ-R
      v-list-item-title.centered {{  selectedGroup? selectedGroup.name:&apos;loading...&apos;  }}
    v-spacer
    //
      <v-badge color="red">
      <v-icon @click="alert('TODO: coming soon!')" class="pr-2">mdi-bell</v-icon>
      </v-badge>
    role-selector(v-if="selectedUser", :user="selectedUser")
    template(v-slot:extension)
      v-btn(
        icon,
        :disabled="!['GA', 'RM'].includes(selectedUser && selectedUser.role)"
      )
        v-icon(
          v-if="selectedRestaurant && selectedRestaurant.status === STATUSES.OPEN",
          @click="vibrate(); closeRestaurant()",
          large,
          color="green"
        ) mdi-toggle-switch
        v-icon(
          v-else,
          large,
          @click="vibrate(); openRestaurant()",
          color="red"
        ) mdi-toggle-switch-off
      restaurant-selector
      v-btn(icon, @click="vibrate(); logout()")
        v-icon mdi-logout
  v-container.animated.slideInLeft.faster.pa-0(fluid)
    v-alert(v-model="showAlert", dismissible, type="error") {{ alertMessage }}
    v-row.pa-0(v-if="mySections.length", no-gutters)
      v-col.pa-0
        v-sheet(color="grey lighten-2")
          div(align="center")
            v-icon(small) mdi-view-sequential
            strong.pl-2 My Sections
    v-divider
    v-row.pa-0(justify-left, no-gutters)
      v-col(v-if="!mySections.length", xs="12", sm="6", md="4", lg="3", xl="2")
        .box(align="center")
          span(v-if="['GA', 'RM'].includes(selectedUser && selectedUser.role)")
            | No sections found. Please add or activate section(s) from
            a(@click="vibrate(); $router.push('/admin')") [Admin]
            |
            | screen
          span(
            v-if="['SS', 'SW', 'SH'].includes(selectedUser && selectedUser.role)"
          ) No sections found. Please check with admin to assign the section(s)
      v-col.pa-0(
        v-for="section in mySections",
        :key="section.id",
        cols="12",
        xs="12",
        sm="6",
        md="4",
        lg="3",
        xl="2"
      )
        e-z-section(:section="section", @openerror="showAreaError($event)") loading...
    v-row.pa-0(v-if="myCounters.length", no-gutters)
      v-col
        v-sheet(color="grey lighten-2")
          div(align="center")
            v-icon(small) mdi-view-parallel
            strong.pl-2 My Counters
    v-row(justify-left, no-gutters)
      v-col.pa-0(
        v-if="!myCounters.length",
        cols="12",
        xs="12",
        sm="6",
        md="4",
        lg="3",
        xl="2"
      )
        .box(align="center")
          span(v-if="['GA', 'RM'].includes(selectedUser && selectedUser.role)")
            | No counters found. Please add or activate counter(s) from
            a(@click="vibrate(); $router.push('/admin')") [Admin]
            |
            | screen
          span(v-if="['CC'].includes(selectedUser && selectedUser.role)") No counters found. Please check with admin to assign the counter(s)
      v-col.pa-0(
        v-for="counter in myCounters",
        :key="counter.id",
        cols="6",
        xs="6",
        sm="3",
        md="2",
        lg="2",
        xl="1"
      )
        e-z-counter(:counter="counter", @openerror="showAreaError($event)") loading...
</template>

<script>
import firebase from "firebase";
import FlipCard from "../components/shared/FlipCard.vue";
import EZSection from "../components/panels/EZSection.vue";
import EZCounter from "../components/panels/EZCounter.vue";
import { storeMixin } from "../mixins/storeMixin.js";
import RoleSelector from "../components/menus/RoleSelector.vue";
import RestaurantSelector from "../components/menus/RestaurantSelector.vue";
import { storage } from "../config/db.js";
import MyFeatures from "../components/shared/MyFeatures.vue";

export default {
  name: "home",
  mixins: [storeMixin],
  components: {
    RoleSelector,
    RestaurantSelector,
    FlipCard,
    EZSection,
    EZCounter,
    MyFeatures,
  },
  async beforeMount() {
    this.fillBusySeats();
    this.myRestaurants = await this.allowedRestaurants;
  },
  data() {
    return {
      myRestaurants: [],
      title: "Home",
      drawer: false,
      searchR: false,
      //bottomMenuItems: this.getBottomMenuItems(),
      activeNav: 0,
      editedItem: {},
      showAlert: false,
      alertMessage: "",
      myCroppa: {},
      cameraDialog: false,
      planDialog: false,
    };
  },
  methods: {
    fillBusySeats() {
      this.sections.forEach((section) => {
        section.tables.forEach((t) => {
          t.seats.forEach((s) => {
            if (s.serviceKey != "rx") s._serviceKey = "";
          });
        });
        const services = this.restaurantServices
          .filter((s) => s._sectionKey == section.id)
          .map((s) => {
            return { id: s.id, seats: s.seats };
          });
        services.forEach((service) => {
          service.seats.forEach((seat) => {
            let [tblIndex, seatIndex] = seat.split("-");
            section.tables[tblIndex].seats[seatIndex]._serviceKey = service.id;
          });
        });
      });
      this.$forceUpdate();
    },
    openRestaurant() {
      const restaurant = this.selectedRestaurant;
      if (
        this.myFeatures.eligibleFeatures.includes("REPORT") &&
        restaurant._managerId != this.selectedUser.id
      ) {
        this.alertMessage = `Restaurant can only be opened by an assigned manager. Please check if you are assigned to this restaurant as manager.`;
        this.showAlert = true;
      } else {
        const report = {
          _groupKey: this.selectedGroup.id,
          _restaurantKey: this.selectedRestaurant.id,
          code: this.selectedRestaurant.code,
          inCharge: this.selectedRestaurant.managerName,
          _inChargeId: this.selectedRestaurant._managerId,
          reportType: "restaurant",
          openTS: Date.now(),
          closedTS: "",
          reportText: "",
          status: this.STATUSES.OPEN,
        };
        this.createDoc({ collectionName: "reports", doc: report });
        restaurant.status = this.STATUSES.OPEN;
        this.updateFields({
          collectionName: "restaurants",
          docId: restaurant.id,
          subDoc: { status: restaurant.status },
        });
        if (!this.myFeatures.eligibleFeatures.includes("REPORT")) {
          //Free version
          //open the section and counter
          this.sections.forEach((s) => {
            s.status = this.STATUSES.OPEN;
            this.updateFields({
              collectionName: "sections",
              docId: s.id,
              subDoc: { status: s.status },
            });
          });
          this.counters.forEach((c) => {
            c.status = this.STATUSES.OPEN;
            this.updateFields({
              collectionName: "counters",
              docId: c.id,
              subDoc: { status: c.status },
            });
          });
        }
      }
    },
    closeRestaurant() {
      const restaurant = this.selectedRestaurant;
      const report = this.restaurantReport;
      if (
        this.myFeatures.eligibleFeatures.includes("REPORT") &&
        report._inChargeId !== this.selectedUser.id
      ) {
        this.alertMessage = `Restaurant can be closed by only whoever opened it(${report.inCharge}). Please check if you have opened it and try closing again`;
        this.showAlert = true;
      } else if (
        !this.myFeatures.eligibleFeatures.includes("REPORT") ||
        this.checkAreasClosed()
      ) {
        this.$router.push(
          `/restaurants/${restaurant.id}/reports/${report.id || ""}`
        );
      }
    },
    checkAreasClosed() {
      const openSections = this.sections
        .filter((s) => s.status === this.STATUSES.OPEN)
        .map((s) => s.code);
      const openCounters = this.counters
        .filter((c) => c.status === this.STATUSES.OPEN)
        .map((c) => c.code);
      const allClosed = [...openSections, ...openCounters].length === 0;
      if (!allClosed) {
        this.alertMessage = `Restaurant cannot be closed when the sections/counters (${[
          ...openSections,
          ...openCounters,
        ].join(", ")}) are open. Please try after closing them.`;
        this.showAlert = true;
      }
      return allClosed;
    },
    showAreaError(message) {
      this.alertMessage = message;
      this.showAlert = true;
    },
    async logout() {
      if (await this.$confirm("Are your sure you want to Sign out?")) {
        this.unbindAll();
        firebase
          .auth()
          .signOut()
          .then(() => {
            this.selectUser(null);
            this.selectGroup(null);
            this.$router.replace("/login");
          });
      }
    },
    uploadImage: function () {
      const storageRef = storage.ref();
      const productRef = storageRef.child(
        `images/groups/${this.selectedGroup.id}/users/${this.selectedUser.id}/${this.selectedUser.code}.jpeg`
      );
      this.myCroppa.generateBlob(
        (blob) => {
          productRef.put(blob).then((snapshot) => {
            snapshot.ref.getDownloadURL().then((url) => {
              //alert("Uploaded a blob or file!" + url);
              this.selectedUser.imageUrl = url;
              this.cameraDialog = false;
              this.updateUser();
            });
          });
        },
        "image/jpeg",
        0.1
      );
    },
    clearImage() {
      this.selectedUser.imageUrl = "";
      this.updateUser();
      this.$forceUpdate();
    },
    updateUser() {
      this.updateFields({
        collectionName: "users",
        docId: this.selectedUser.id,
        subDoc: { imageUrl: this.selectedUser.imageUrl },
      });
    },
  },
  watch: {
    restaurantServices() {
      this.fillBusySeats();
    },
    sections() {
      this.fillBusySeats();
    },
  },
};
</script>
<style >
.header {
  float: right;
  width: 100%;
}
.centered {
  text-align: center;
}
.v-badge__badge {
  height: 10px;
  width: 10px;
  left: 0px;
  top: 0px;
}
</style>